export default "__VITE_ASSET__4e266f02__"